
export const OPEN_SELECT = 'OPEN_SELECT';
export const OPEN_LOCATION = 'OPEN_LOCATION';
export const CLOSE_SELECT = 'CLOSE_SELECT';
export const CLOSE_LOCATION = 'CLOSE_LOCATION';
export const SELECT = 'SELECT';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const SELECT_CURRENCY = 'SELECT_CURRENCY';
export const SELECT_LOCATION = 'SELECT_LOCATION';
export const SELECT_DATE = 'SELECT_DATE';
export const CHANGE_PERIOD = 'CHANGE_PERIOD';

export const FETCH_CURRENCY_PENDING = 'FETCH_CURRENCY_PENDING';
export const FETCH_CURRENCY_SUCCESS = 'FETCH_CURRENCY_SUCCESS';
export const FETCH_CURRENCY_ERROR = 'FETCH_CURRENCY_ERROR';

export const FETCH_CHART_PENDING = 'FETCH_CHART_PENDING';
export const FETCH_CHART_SUCCESS = 'FETCH_CHART_SUCCESS';
export const FETCH_CHART_ERROR = 'FETCH_CHART_ERROR';

export const FETCH_BANKS_PENDING = 'FETCH_BANKS_PENDING';
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
export const FETCH_BANKS_ERROR = 'FETCH_BANKS_ERROR';

export const FETCH_BRANCHES_PENDING = 'FETCH_BRANCHES_PENDING';
export const FETCH_BRANCHES_SUCCESS = 'FETCH_BRANCHES_SUCCESS';
export const FETCH_BRANCHES_ERROR = 'FETCH_BRANCHES_ERROR';

export const SORT_ASC_SELL = 'SORT_ASC_SELL';
export const SORT_DESC_SELL = 'SORT_DESC_SELL';
export const SORT_ASC_BUY = 'SORT_ASC_BUY';
export const SORT_DESC_BUY = 'SORT_DESC_BUY';

export const LOCATION_TRANSLATE = 'LOCATION_TRANSLATE';

